import select from './StaticSingleSelect.vue'
const StaticSingleSelect = {
	install: function(Vue) {
		Vue.component('StaticSingleSelect', select)
	}
}
export default StaticSingleSelect
